// extracted by mini-css-extract-plugin
export var actionText = "_s9-4";
export var container = "_s9-0";
export var leftSection = "_s9-1";
export var rightSection = "_s9-2";
export var settingsButton = "_s9-6";
export var settingsIcon = "_s9-7";
export var shortcut = "_s9-5";
export var shortcutGroup = "_s9-3";